export default __webpack_public_path__ + "static/media/link.0d55fb97.svg";